import { StyleSheet } from 'react-native';

export const deliStyles = StyleSheet.create({
  deliWrapper: {
   height: '100vh',
   width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 15,
    backgroundColor: '#32de84',
  
  },
  delitext: {
    color: 'white',
    fontWeight:'bold',
  },
});
